"use strict";

function groupsToString(groups) {
  var ids = "";
  angular.forEach(groups, function(v, k){
    if (angular.isObject(v)) {
      if (k === 0) {
        ids = v.id;
      } else {
        ids = ids + ',' + v.id;
      }
    } else if (angular.isString(v)) {
      if (k === 0) {
        ids = v;
      } else {
        ids = ids + ',' + v;
      }
    }
  });
  return ids;
}

function GroupMembersDirective($stateParams, CompanyUserService, $modal) {
  return {
    restrict: 'A',
    require: '^ngModel',
    scope: {
      showAllUsers: "=?",
      seeAllObjects: "=?"
    },
    link: function(scope, elm, attrs, ngModel) {
      var LIMIT = 20;
      scope.page = 0;
      scope.hasMore = false;
      if (!attrs.customTitle) {
        scope.customTitle = 'publication.user-access';
      } else {
        scope.customTitle = attrs.customTitle;
      }
      ngModel.$render = function() {
        scope.listGroups = ngModel.$modelValue;
        loadMembers(scope.listGroups);
        scope.$watch('listGroups', function(newData, oldData) {
          if (newData === oldData) {
            return;
          }
          loadMembers(scope.listGroups);
        }, true);

        var usersModal = $modal({
          controller: ShowAllUsersCtrl,
          templateUrl: 'partials/company/publications/members-group/modal.html',
          show: false,
          resolve: {
            groups: function() {
              return groupsToString(scope.listGroups);
            }
          }
        });
        scope.showModal = function() {
          usersModal.$promise.then(usersModal.show);
        };
      };
      function loadMembers(groups) {
        scope.hasMore = false;

        if (scope.seeAllObjects) {
          CompanyUserService.query({companyId: $stateParams.companyId, seeAllObjects: true, all: true}).$promise.then(function(resp){
            scope.members = resp;
          });
        } else {
          var ids = groupsToString(groups),
            params = {
              companyId: $stateParams.companyId,
              groupIds: ids
            };
          if (scope.showAllUsers) {
            params.all = true;
          } else {
            params.limit = LIMIT + 1;
          }

          if (ids !== "") {
            CompanyUserService.query(params).$promise.then(function(resp){
              if (!scope.showAllUsers) {
                if (resp.length === LIMIT + 1) {
                  scope.hasMore = true;
                  resp.pop();
                }
              }
              scope.members = resp;
            });
          }
        }
      }
    },
    templateUrl:'partials/company/publications/members-group/main.html'
  };
}

ShowAllUsersCtrl.$inject = ['$scope', 'groups', '$stateParams', 'CompanyUserService'];
function ShowAllUsersCtrl($scope, groups, $stateParams, CompanyUserService) {
  $scope.members = [];
  if (groups !== "") {
    CompanyUserService.query({
      companyId: $stateParams.companyId,
      groupIds: groups,
      all: true
    }).$promise.then(function(resp){
      $scope.members = resp;
    });
  }
}

angular.module('dokiv')
  .directive('groupMembers', ['$stateParams', 'CompanyUserService', '$modal', GroupMembersDirective]);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/GroupMembersDirective.js
// module id = 245
// module chunks = 0